export default "__VITE_ASSET__d5470410__"